import { pagesConfig } from '../../../shared/pages-config';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import { useUserSettings } from '../../../utils/use-user-settings';
import RulesEngineFormPage from './rules-engine-form-page';
import RulesEngineFormPageOld from './rules-engine-form-page-old';

export default function CreateRulePage() {
  const { features } = useUserSettings();

  return isFeatureEnabled('rulesEnginev2UiReact', features) ? (
    <RulesEngineFormPage
      pageMode="create"
      title={pagesConfig.createRule.name}
    />
  ) : (
    <RulesEngineFormPageOld
      pageMode="create"
      title={pagesConfig.createRule.name}
    />
  );
}
